// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae69a411","732":"821d97a3","977":"c7563953"}[chunkId] + ".chunk.js";
};